import clsx from 'clsx';
import { forwardRef } from 'react';

import Box from '@/componentsv2/Box';

import { ITagProps } from './types';

const testId = 'of-tag';

const Tag = forwardRef<HTMLDivElement | HTMLButtonElement, ITagProps>(
  (
    {
      className,
      children,
      startIcon,
      endIcon,
      onClick,
      size = 'md',
      disabled,
      isNew,
      textClassName,
      isClickable,
      ...rest
    },
    ref
  ) => {
    const clickable = isClickable || !!onClick;
    return (
      <Box
        ref={ref}
        component={clickable ? 'button' : 'div'}
        onClick={onClick}
        className={clsx(className, 'inline-flex items-center rounded-md border shadow-5', {
          'gap-2 p-4 subtitle-2': size === 'sm',
          'gap-8 px-8 py-6 subtitle-1': size === 'md',
          'border-surface-border bg-surface-elevated text-on-surface': !isNew,
          'border-green-800 bg-green-900/30 text-green-400': isNew,
          'hover:bg-surface-secondary': !isNew && clickable,
        })}
        data-testid={testId}
        {...(clickable && disabled ? { disabled: 'disabled' } : {})}
        {...rest}
      >
        {startIcon ? startIcon : null}
        {children ? (
          <span className={clsx(textClassName, { 'px-4': size === 'sm' })}>{children}</span>
        ) : null}
        {endIcon ? endIcon : null}
      </Box>
    );
  }
);

Tag.displayName = 'Tag';

export { testId as TagTestId };
export type { ITagProps };
export default Tag;
